import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { LISTING_STATUS } from "constants/general";
import { ROUTES } from "constants/routes";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getUTCYMD } from "utils/timestamp.util";

const TypeMaps: any = {
  1: "Tractor",
  2: "Attachment",
};
const MyListingListItem = ({
  id,
  images,
  listing_name,
  listing_description,
  listing_type,
  price,
  setDeleteId,
  listing_status,
  bookings,
}: {
  id: number;
  images: any;
  listing_name: string;
  listing_description: string;
  listing_type: number;
  price: number;
  setDeleteId: any;
  listing_status: any;
  bookings: any;
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  return (
    <Card
      sx={{ borderRadius: 0, height: "100%", background: "#FFF" }}
      elevation={0}
    >
      <CardMedia
        sx={{
          height: {
            md: "256px",
            lg: "256px",
            xl: "256px",
            sm: "144px",
            xs: "144px",
          },
          width: "100%",
          borderRadius: "10px",

          backgroundPosition: "center",
        }}
        image={images[0]?.preview_url || "/assets/img/empty-img.jpg"}
        title={listing_name}
        onClick={() => navigate(`/listing-detail-owner/${id}`)}
      >
        <Chip
          label={TypeMaps[listing_type || 0] as string}
          sx={{
            background: "#FFFFFF",
            mx: { md: "20px", lg: "20px", xl: "20px", sm: "10px", xs: "10px" },
            my: { md: "15px", lg: "15px", xl: "15px", sm: "10px", xs: "10px" },
            float: "right",
            color: "#323232",
            fontSize: {
              md: "13px",
              lg: "13px",
              xl: "13px",
              sm: "11px",
              xs: "11px",
            },
            fontWeight: 500,
            lineHeight: "16px",
            minWidth: "104px",
          }}
          component={Paper}
        />
      </CardMedia>
      <CardContent sx={{ padding: "10px 0px" }}>
        <Grid container spacing={1.5}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            onClick={() => navigate(`/listing-detail-owner/${id}`)}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#323232",

                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",

                // height: "55px",
              }}
            >
              {listing_name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 500,
                color: "#A2A2A2",
                lineHeight: "22px",

                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",

                height: "48px",
              }}
            >
              {listing_description.slice(0, 70)}
              {listing_description.length > 70 ? "..." : ""}

              {listing_description.length > 70 && (
                <Typography
                  component="span"
                  sx={{
                    color: "#307AFF",
                    fontSize: "15px",
                    fontWeight: "400",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate(`/listing-detail-owner/${id}`)}
                >
                  &nbsp;Read More
                </Typography>
              )}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            onClick={() => navigate(`/listing-detail-owner/${id}`)}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: {
                  md: "space-between",
                  lg: "space-between",
                  xl: "space-between",
                  sm: "flex-start",
                  xs: "flex-start",
                },
                alignItems: "center",
                // flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    md: "24px",
                    lg: "24px",
                    xl: "24px",
                    sm: "18px",
                    xs: "18px",
                  },
                  fontWeight: 600,
                  lineHeight: "31px",
                  color: "#323232",
                }}
              >
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  currencyDisplay: "narrowSymbol",
                }).format(price)}
                /
                <Typography
                  component="span"
                  sx={{
                    fontSize: {
                      md: "15px",
                      lg: "15px",
                      xl: "15px",
                      sm: "13px",
                      xs: "13px",
                    },
                    fontWeight: 600,
                    lineHeight: "31px",
                    color: "#323232",
                  }}
                >
                  Day
                </Typography>
              </Typography>
              <Typography
                sx={{
                  display: {
                    md: "none",
                    lg: "none",
                    xl: "none",
                    sm: "block",
                    xs: "block",
                  },
                  color: "#4EA643",
                  fontWeight: 600,
                  fontSize: "13px",
                  lineHeight: "31px",
                }}
              >
                &nbsp;
                <Typography component="span" sx={{ color: "#323232", p: 0 }}>
                  •
                </Typography>
                &nbsp;{" "}
                <Typography
                  component="span"
                  sx={{
                    color:
                      listing_status === LISTING_STATUS.UNDER_REVIEW
                        ? "#F1B724"
                        : listing_status === LISTING_STATUS.REJECTED
                        ? "#D21A00"
                        : "#4EA643",
                    fontWeight: 600,
                    fontSize: "13px",
                    lineHeight: "31px",
                  }}
                >
                  {listing_status === LISTING_STATUS.UNDER_REVIEW
                    ? "Pending"
                    : listing_status === LISTING_STATUS.REJECTED
                    ? "Rejected"
                    : listing_status === LISTING_STATUS.APPROVED && !bookings
                    ? "Published"
                    : listing_status === LISTING_STATUS.APPROVED && bookings
                    ? "Booked"
                    : ""}
                </Typography>
              </Typography>

              {listing_status === LISTING_STATUS.UNDER_REVIEW && (
                <Chip
                  label="Pending"
                  sx={{
                    display: {
                      md: "flex",
                      lg: "flex",
                      xl: "flex",
                      sm: "none",
                      xs: "none",
                    },
                    background: "#FEF6E1",
                    color: "#F1B724",
                  }}
                />
              )}
              {listing_status === LISTING_STATUS.REJECTED && (
                <Chip
                  label="Rejected"
                  sx={{
                    display: {
                      md: "flex",
                      lg: "flex",
                      xl: "flex",
                      sm: "none",
                      xs: "none",
                    },
                    background: "#FFEFED",
                    color: "#D21A00",
                  }}
                />
              )}
              {listing_status === LISTING_STATUS.APPROVED && (
                <Chip
                  label="Published"
                  sx={{
                    display: {
                      md: "flex",
                      lg: "flex",
                      xl: "flex",
                      sm: "none",
                      xs: "none",
                    },
                    background: "#EFFFED",
                    color: "#4EA643",
                  }}
                />
              )}
            </Box>
          </Grid>
          {!bookings && (
            <Grid item xs={false} sm={false} md={12} lg={12} xl={12}>
              <Box
                sx={{
                  display: {
                    md: "flex",
                    lg: "flex",
                    xl: "flex",
                    sm: "none",
                    xs: "none",
                  },
                  gap: "15px",
                }}
              >
                <Button
                  color="error"
                  variant="outlined"
                  sx={{ borderRadius: "10px", height: "48px" }}
                  fullWidth
                  onClick={() => setDeleteId(id)}
                >
                  Delete
                </Button>

                <Button
                  color="primary"
                  variant="contained"
                  sx={{ borderRadius: "10px", height: "48px" }}
                  fullWidth
                  onClick={() =>
                    navigate(`${ROUTES.EQUPIMENT_LISTING}?id=${id}`)
                  }
                  disabled={
                    listing_status === LISTING_STATUS.PENDING ||
                    listing_status === LISTING_STATUS.UNDER_REVIEW
                  }
                >
                  Edit Details
                </Button>
              </Box>
            </Grid>
          )}
          {bookings && !matchesSm && !matchesXs && (
            <Grid item xs={false} sm={false} md={12} lg={12} xl={12}>
              <Box
                sx={{
                  width: "100%",
                  background: "#EFFFED",
                  borderRadius: "10px",
                  height: "48px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ color: "#4EA643", fontWeight: 500, fontSize: "15px" }}
                >
                  Booked From{" "}
                  {moment(getUTCYMD(bookings?.from_date)).format("MMM DD")} -{" "}
                  {moment(getUTCYMD(bookings?.to_date)).format("MMM DD")}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MyListingListItem;
